var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "ruleForm",
      staticClass: "demo-ruleForm",
      attrs: {
        model: _vm.form,
        "label-width": _vm.formData.labelWidth,
        inline: _vm.formData.inline,
        rules: _vm.formData.rules,
        size: _vm.formData.size,
        "label-position": _vm.formData.labelPosition,
      },
    },
    [
      _c(
        "el-row",
        { staticClass: "marRight20" },
        [
          _vm._l(_vm.formData.formItem, function (item, index) {
            return _c(
              "el-col",
              { key: index, attrs: { span: item.span } },
              [
                item.type === "title"
                  ? _c("el-row", { staticClass: "title" }, [
                      _c("h3", [_vm._v(_vm._s(item.title))]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "marginLeft" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: item.label, prop: item.prop } },
                      [
                        item.type === "text"
                          ? _c("div", { staticClass: "div" }, [
                              _c("i", { staticClass: "el-icon-info" }),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(item.txt))]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item.type === "suffix"
                          ? _c(
                              "el-input",
                              {
                                attrs: { placeholder: item.placeholder },
                                model: {
                                  value: _vm.form[item.prop],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, item.prop, $$v)
                                  },
                                  expression: "form[item.prop]",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v(_vm._s(item.suffix)),
                                ]),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.type === "limit"
                          ? _c("el-input", {
                              attrs: {
                                type: "textarea",
                                placeholder: item.placeholder,
                                maxlength: item.maxlength,
                                "show-word-limit": "",
                              },
                              model: {
                                value: _vm.form[item.prop],
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, item.prop, $$v)
                                },
                                expression: "form[item.prop]",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        item.type === "input"
                          ? _c("el-input", {
                              attrs: {
                                disabled: item.isDisabled,
                                placeholder: item.placeholder,
                              },
                              model: {
                                value: _vm.form[item.prop],
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, item.prop, $$v)
                                },
                                expression: "form[item.prop]",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        item.type === "password"
                          ? _c("el-input", {
                              attrs: {
                                type: "password",
                                disabled: item.isDisabled,
                              },
                              model: {
                                value: _vm.form[item.prop],
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, item.prop, $$v)
                                },
                                expression: "form[item.prop]",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        item.type === "radio"
                          ? _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.form[item.prop],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, item.prop, $$v)
                                  },
                                  expression: "form[item.prop]",
                                },
                              },
                              _vm._l(item.options, function (item) {
                                return _c(
                                  "el-radio",
                                  {
                                    key: item.value,
                                    attrs: { label: item.value },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.name) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              }),
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.type === "radioButton"
                          ? _c(
                              "el-radio-group",
                              {
                                attrs: { disabled: item.isDisabled },
                                model: {
                                  value: _vm.form[item.prop],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, item.prop, $$v)
                                  },
                                  expression: "form[item.prop]",
                                },
                              },
                              _vm._l(item.options, function (item) {
                                return _c(
                                  "el-radio-button",
                                  {
                                    key: item.value,
                                    attrs: { label: item.value },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.name) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              }),
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.type === "checkbox"
                          ? _c(
                              "el-checkbox-group",
                              {
                                model: {
                                  value: _vm.form[item.prop],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, item.prop, $$v)
                                  },
                                  expression: "form[item.prop]",
                                },
                              },
                              _vm._l(item.options, function (item) {
                                return _c(
                                  "el-checkbox",
                                  {
                                    key: item.value,
                                    attrs: {
                                      disabled: item.isDisabled,
                                      label: item.value,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.name) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              }),
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.type === "select"
                          ? _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  multiple: item.multiple,
                                  "collapse-tags": "",
                                  clearable: "",
                                  disabled: item.isDisabled,
                                  placeholder: item.placeholder,
                                  filterable: "",
                                },
                                model: {
                                  value: _vm.form[item.prop],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, item.prop, $$v)
                                  },
                                  expression: "form[item.prop]",
                                },
                              },
                              _vm._l(item.options, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                    disabled: item.isDisabled,
                                  },
                                })
                              }),
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.type === "cascader"
                          ? _c("el-cascader", {
                              attrs: {
                                options: item.options,
                                props: item.isMore,
                                clearable: "",
                              },
                              model: {
                                value: _vm.form[item.prop],
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, item.prop, $$v)
                                },
                                expression: "form[item.prop]",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        item.type === "switch"
                          ? _c("el-switch", {
                              model: {
                                value: _vm.form[item.prop],
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, item.prop, $$v)
                                },
                                expression: "form[item.prop]",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        item.type === "date"
                          ? _c("el-date-picker", {
                              attrs: {
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                placeholder: "选择日期",
                              },
                              model: {
                                value: _vm.form[item.prop],
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, item.prop, $$v)
                                },
                                expression: "form[item.prop]",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        item.type === "time"
                          ? _c("el-time-picker", {
                              attrs: { placeholder: "请选择时间" },
                              model: {
                                value: _vm.form[item.prop],
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, item.prop, $$v)
                                },
                                expression: "form[item.prop]",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        item.type === "dateTime"
                          ? _c("el-date-picker", {
                              attrs: {
                                type: "datetime",
                                placeholder: "选择日期时间",
                              },
                              model: {
                                value: _vm.form[item.prop],
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, item.prop, $$v)
                                },
                                expression: "form[item.prop]",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        item.type === "datetimerange"
                          ? _c("el-date-picker", {
                              attrs: {
                                type: "datetimerange",
                                "range-separator": "至",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                              },
                              model: {
                                value: _vm.form[item.prop],
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, item.prop, $$v)
                                },
                                expression: "form[item.prop]",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _vm._v(" "),
          _vm._l(_vm.formData.formAddItem, function (i, j) {
            return _c("el-col", { key: j + "x", attrs: { span: i.span } }, [
              _c(
                "div",
                { staticClass: "marginLeft" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: i.label } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 16 } },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: i.isDisabled,
                              placeholder: i.placeholder,
                            },
                            model: {
                              value: i.value,
                              callback: function ($$v) {
                                _vm.$set(i, "value", $$v)
                              },
                              expression: "i.value",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "padding-left": "15px" },
                          attrs: { span: 8 },
                        },
                        [
                          j === 0
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    plain: "",
                                    type: "primary",
                                    size: "mini",
                                  },
                                  on: { click: _vm.addDomain },
                                },
                                [_vm._v("新增")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.formData.formAddItem.length !== 1
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    size: "mini",
                                    plain: "",
                                    type: "danger",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.remove(i)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ])
          }),
          _vm._v(" "),
          _vm.formData.addForm
            ? _c(
                "el-col",
                { staticClass: "addWorksItem" },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary", plain: "", size: "small" } },
                    [_vm._v("新增作品项")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { attrs: { type: "danger", plain: "", size: "small" } },
                    [_vm._v("删除作品项")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { staticClass: "submitBtn" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.onSubmit("ruleForm")
                },
              },
            },
            [_vm._v(" 保存 ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.resetForm("ruleForm")
                },
              },
            },
            [_vm._v(" 重置 ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }